.root {
  color: var(--color-foreground);
}

.root-size-2xl {
  font-size: 28px;
  font-weight: 700;
}

.root-size-xl {
  font-size: 20px;
  font-weight: 700;
}

.root-size-lg {
  font-size: 18px;
  font-weight: 700;
}

.root-size-md {
  font-size: 16px;
  font-weight: 600;
}

.root-size-sm {
  font-size: 14px;
  font-weight: 600;
}

.root-variant-accent {
  color: var(--color-link);
}
